import ListsTable from "@dashboard/features/Dashboard/Lists/ListsTable";
import { createFileRoute } from "@tanstack/react-router";
import { Card } from "frontend-components";
import { z } from "zod";
import { dashboardModalSearchSchema } from "../route";

const listsSearchSchema = dashboardModalSearchSchema.extend({
    status: z.enum(["active", "completed"]).optional().catch(undefined),
    search: z.string().optional().catch(undefined),
    view: z.enum(["templates"]).optional().catch(undefined),
});

export type ListsSearch = z.infer<typeof listsSearchSchema>;

export const Route = createFileRoute("/_hub/$customerId/dashboard/$profileId/lists")({
    component: RouteComponent,
    validateSearch: listsSearchSchema,
    staticData: {
        titleFn: null,
    },
});

function RouteComponent() {
    return (
        <Card className="bg-transparent p-0 xl:bg-compendia-card xl:p-8">
            <ListsTable />
        </Card>
    );
}
